import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ISortOrder
{
  readonly orderBy: string;
  ascending: boolean;
}

@Component({
  selector: 'app-sort-toggle',
  templateUrl: './sort-toggle.component.html',
  styleUrls: ['./sort-toggle.component.scss']
})
export class SortToggleComponent implements OnInit, ISortOrder {

  static selectedSorts = new Map<string, string>();

  public get orderBy(): string {
    return SortToggleComponent.selectedSorts[this.setName];
  }

  ascending: boolean = true;

  @Output() orderChange = new EventEmitter<SortToggleComponent>();
  @Input() columnName: string;
  @Input() setName: string = "default";

  ngOnInit() {

  }

  clicked(): void {
    if (this.isSelected()) {
      this.ascending = !this.ascending;
    }
    else {
      SortToggleComponent.selectedSorts[this.setName] = this.columnName;
    }
    this.orderChange.emit(this);
  }

  public isSelected(): boolean {
    return SortToggleComponent.selectedSorts[this.setName] === this.columnName;
  }
}
